import React, { useState } from "react";
import { auth, db } from "./firebaseConfig";
import { createUserWithEmailAndPassword } from "firebase/auth";
import {doc, setDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { FaLock, FaUser } from "react-icons/fa";
import { MdDriveFileRenameOutline } from "react-icons/md";
import "./styles.css";

const Signup = () => {
  const [username, setUsername] = useState(""); 
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleSignup = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user; 

      
      await setDoc(doc(db, "users", user.uid), {
        username: username,
        email: user.email, 
        bio: "",
        savedQuizzes: [],
        quizHistory: [],
      });

      alert("Signup successful!");
      navigate("/login"); 
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <div className='wrapper'>
      <h2>Signup</h2>
      <form onSubmit={handleSignup}>
        <div className="input-box">
        <input type="text" placeholder="Username" onChange={(e) => setUsername(e.target.value)} required /> <MdDriveFileRenameOutline className='icon' />
        </div>
        <div className="input-box">
        <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required /> <FaUser className='icon' />
        </div>
        <div className="input-box">
        <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required /> <FaLock className='icon' />
        </div>
        <button type="submit">Signup</button>
      </form>
    </div>
  );
};

export default Signup;
